module.exports = __webpack_public_path__ + "media/books/ArtBooks-hero-crop-x2-5697d662.jpg";